import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Scrollbar from 'react-scrollbars-custom'
import Back from '../../../../features/back/Back'
import { safeHTML } from '../../../../../utils/safeHTML'
import CustomButton from '../../../../features/customButton/ui/main/CustomButton'
import { useModal } from '../../../../../hooks/useModal'
import { useCreateShareLink } from '../../../../../hooks/createShareLink'
import { image } from '../../../../../utils/data/baseUrl'
import { useRequestsHandlerData } from '../../../../../hooks/useRequestsHandlerData'
import { saveRoomAsBase64 } from '../../../../../utils/sharing/share-elf'
import { useDispatch } from 'react-redux'
import { findGetParameter } from '../../../../../utils/scene/utils/findGetParameter'
import classNames from 'classnames'
import { GTMAddFriend, GTMShare } from '../../../../../constants/analytics/GTM'
import AppLoader from '../../../../features/appLoader/AppLoader'
import { useExtraProfile } from '../../../../../hooks/useExtraProfile'
import useStateControls from '../../../../../hooks/useStateControls'
import Item from '../item/Item'
import { useActivePremiumAchievementIcon } from '../../../../../hooks/shared/achievements/useActivePremiumAchievementIcon'
import { defaultStore, stores, useTranslation } from '../../../../../translations'
import Achievements from '../achievements/Achievements'
import useNewYearProfileModal from '../../model/hooks/useNewYearProfileModal'
import useMarch8ModalCongratulate from '../../model/hooks/useMarch8ModalCongratulate'
import content from '../../constants/content'
import { addFriend, compilationScrollbarSettings } from '../../../../../constants/copyright'
import { useUser } from '../../../../../redux/reducer/user'
import MyId from '../../../../features/myId/MyId'
import requests, { useRequests } from '../../../../../redux/reducer/requests'
import { setShowMessage, useContent } from '../../../../../redux/reducer/content'
import Presents from '../presents/Presents'
import Buffs from '../../../../features/buffs/main/Buffs'
import Postcard from '../postcard/Postcard'
import { useFeatureToggle } from '../../../../../hooks/useFeatureToggle'
import Icon from '../../../../baseComponents/gui/icon/Icon'

export const PER_PAGE = 50
export const offsetScrollY = 200

const { title, text, note, buttons } = content
//TODO: рефакторить
const Friends = React.forwardRef(function ({ callbacks }, ref) {
  const {
    authData: { isWeb },
  } = useRequests()
  const {
    favorites,
    profile: { username, likesCount },
    profile,
  } = useUser()
  const { shopItems, showMessage } = useContent()
  const { addModal } = useModal()
  const dispatch = useDispatch()
  const [shareAvailable, setShareAvailable] = useState(true)
  const [copied, setCopied] = useState(false)
  const createShareLink = useCreateShareLink()
  const [page, setPage] = useState(1)
  const [pageCount, setPageCount] = useState(1)
  const { setState } = useStateControls()
  const { t } = useTranslation()
  const iconImage = useActivePremiumAchievementIcon()
  const isPending = useExtraProfile()
  const gameTamagotchiPromo8March = useFeatureToggle('gameTamagotchiPromo8March')
  const isPendingFavorites = useRequestsHandlerData([
    {
      address: 'requestsWishBuyGift',
    },
    {
      address: 'requestsUserGetFavorites',
      fulfilled: ({ _meta: { pageCount } }) => setPageCount(pageCount),
    },
    {
      address: 'requestsUserSaveShareImage',
      fulfilled: () => onLinkCreated(),
      settled: () => setShareAvailable(true),
    },
  ])

  const toMain = () => {
    setState('main')
  }

  const handleScroll = ({ scrollTop, scrollHeight, clientHeight }) => {
    if (scrollTop + clientHeight + offsetScrollY < scrollHeight || isPendingFavorites) return
    page < pageCount && setPage((prev) => ++prev)
  }
  const onLinkCreated = useCallback(() => {
    const url = createShareLink()
    navigator.clipboard.writeText(url).then(() => setCopied(true))
    if (findGetParameter('showSharing'))
      saveRoomAsBase64({ ...profile, shopItems }, undefined, true)
  }, [shopItems, profile])

  const onShare = useCallback(async () => {
    GTMShare()
    if (profile.shareImageExists) return onLinkCreated()

    setShareAvailable(false)
    const base64 = await saveRoomAsBase64({ ...profile, shopItems })
    dispatch(requests.thunks.saveShareImage(base64))
  }, [profile, shopItems])

  useEffect(() => {
    if (!showMessage) return
    const t = setTimeout(() => dispatch(setShowMessage(false)), 3000)
    return () => clearTimeout(t)
  }, [showMessage])

  useEffect(() => {
    callbacks.getFavorites({ page, perPage: PER_PAGE })
  }, [page])

  useEffect(() => {
    callbacks.resetFriends()
  }, [])

  useEffect(() => {
    if (!copied) return
    const timeout = setTimeout(() => setCopied(false), 2000)
    return () => clearTimeout(timeout)
  }, [copied])

  useNewYearProfileModal()
  useMarch8ModalCongratulate()

  const likes = useMemo(() => {
    return Number(
      !Array.isArray(likesCount) &&
        Object.values(likesCount ?? {}).reduce((acc, like) => acc + like, 0),
    )
  }, [likesCount])

  return (
    <section
      className={classNames('friends', {
        app: !isWeb,
      })}
      ref={ref}
    >
      <Back onClick={toMain} />
      <div className={'friends__content'}>
        <div className={'friends__header'}>
          <h2 className={'friends__title'}>
            {safeHTML(username)}
            {iconImage && (
              <img
                src={iconImage}
                className={'friends__icon'}
                alt={''}
              />
            )}
          </h2>

          <div className={'friends__profile'}>
            <div className={'friends__profile-likes'}>
              <Icon name={'profile/heart'} />
              <span>{likes}</span>
            </div>

            <div className={'friends__profile-id'}>
              <Icon name={'profile/person'} />
              <MyId simpleStyle />
            </div>
          </div>

          {defaultStore !== stores.ae && gameTamagotchiPromo8March && <Postcard />}
          <Presents />
          <Buffs />
          <Achievements />
          <h2 className={'friends__subtitle'}>{safeHTML(t(title))}</h2>
          <p
            className={classNames('friends__text', { friends__text_stub: favorites?.length === 0 })}
          >
            {safeHTML(t(text))}
          </p>
        </div>
        {!!favorites?.length ? (
          <div className={'friends__list'}>
            <Scrollbar
              {...compilationScrollbarSettings}
              onScroll={handleScroll}
            >
              {favorites?.map((friendData) => (
                <Item
                  key={friendData.uid}
                  {...friendData}
                />
              ))}
            </Scrollbar>
          </div>
        ) : (
          <img
            src={image('friends/img2.png')}
            className={'friends__stub'}
            alt={''}
          />
        )}

        {!favorites?.length && <div className={'friends__note'}>{safeHTML(t(note))}</div>}

        <div className={'friends__buttons'}>
          <CustomButton
            text={buttons[0].text}
            className={'custom-button_ny-gray button_friend friends__button'}
            disabled={!shareAvailable || copied}
            onClick={() => {
              onShare()
              dispatch(setShowMessage(t('other.linkCopied')))
            }}
          />
          <CustomButton
            text={buttons[1].text}
            className={'button_friend friends__button'}
            onClick={() => {
              GTMAddFriend()
              addModal({ type: 'addFriendModal', props: { ...addFriend, callbacks } })
            }}
          />
        </div>
      </div>
      {(isPending || isPendingFavorites) && <AppLoader />}
    </section>
  )
})
export default Friends
Friends.propTypes = {}
